import { useState, useMemo } from 'react';
import ShopLayout from '../components/ShopLayout';
import DealCard from '../components/DealCard';
import { ROUTER_DATA, ROUTER_CATEGORIES } from '../data/routerData';

export default function RouterDataPage() {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('All');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return ROUTER_DATA.filter(r => {
      const matchCat = category === 'All' || r.category === category;
      const matchSearch = !q || r.name.toLowerCase().includes(q) || r.package?.toLowerCase().includes(q);
      return matchCat && matchSearch;
    });
  }, [search, category]);

  return (
    <ShopLayout
      title="Routers & Data Deals"
      subtitle="Home internet, prepaid bundles, SIM-only and more — stay connected on your terms."
      search={search}
      onSearch={setSearch}
      filters={ROUTER_CATEGORIES}
      activeFilter={category}
      onFilter={setCategory}
    >
      {filtered.length === 0
        ? <p className="shop-empty">No deals match your search.</p>
        : filtered.map(r => <DealCard key={r.id} deal={r} type="routerData" />)
      }
    </ShopLayout>
  );
}
